/** Referência da data dos títulos */
export interface TituloReceberReferenciaData {
    id: number;
    nome: string;
}

export const referenciaDataEmissao: TituloReceberReferenciaData = {id: 1, nome: 'Emissão'};
export const referenciaDataVencimento: TituloReceberReferenciaData = {id: 2, nome: 'Vencimento'};
export const referenciaDataPagamento: TituloReceberReferenciaData = {id: 3, nome: 'Pagamento'};
export const referenciaDataAtualizacaoFinanceira: TituloReceberReferenciaData = {id: 4, nome: 'Atualização Financeira'};

export const tituloReceberReferenciasData: TituloReceberReferenciaData[] = [
    referenciaDataEmissao,
    referenciaDataVencimento,
    referenciaDataPagamento,
    referenciaDataAtualizacaoFinanceira
];
